import React, { useEffect, useRef } from 'react';
import VanillaTilt from 'vanilla-tilt';

function Tilt(props) {
  const { children, options, ...rest } = props;
  const element = useRef(null);

  useEffect(() => {
    let el = element.current;

    VanillaTilt.init(el, options);

    return () => el.vanillaTilt.destroy();
  }, [options]);

  return (
    <div ref={element} {...rest}>
      {children}

      {/* <style jsx>{`
        div {
          transform: translateZ(-100px);
        }
      `}</style> */}
    </div>
  );
}

export default Tilt;
